import styled from 'styled-components/native';

export const Container = styled.TouchableOpacity``;
export const Icon = styled.Image`
  width: 40px;
  height: 40px;
  margin-right: 10px;
`;
